/** Outlook folder path, e.g. "Ordersystem/Hanterat". */
export function outlookFolderName(folder: string | null | undefined): string | null {
  const trimmed = folder?.trim()
  if (!trimmed) return null
  return trimmed
}
